// extracted by mini-css-extract-plugin
module.exports = {"row":"EnrollClinic_row__3PZB0"};